import common from "./common";
import cloudInterface from "@/views/cloudInterface/cloudInterface.zh-CN";
import admin from "@/views/admin/admin.zh-CN.js";
import login from "@/views/login/login.zh-CN.js";
import statistics from "@/views/statistics/statistics.zh-CN.js";
import screen from "@/views/screen/screen.zh-CN.js";
import components from "@/components/components.zh-CN.js";
import install from "@/views/install/install.zh-CN";
const locale = {
  common,
  cloudInterface,
  admin,
  login,
  statistics,
  screen,
  components,
  install
};
export default locale;



// WEBPACK FOOTER //
// ./src/locale/lang/zh-CN/index.js